import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { Switch } from '../primitives/Switch'
import { Label } from '../primitives/Label'
import { cn } from '@/lib/utils'

interface FormSwitchProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  disabled?: boolean
  className?: string
  rules?: Record<string, unknown>
}

export function FormSwitch<T extends FieldValues>({
  control,
  name,
  label,
  disabled = false,
  className,
  rules,
}: FormSwitchProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div className={cn('flex items-center gap-2', className)}>
          <Switch
            checked={field.value}
            disabled={disabled}
            onCheckedChange={field.onChange}
          />
          {label && (
            <Label
              className="cursor-pointer text-sm font-medium text-neutral-800"
              htmlFor={name}
              onClick={() => !disabled && field.onChange(!field.value)}
            >
              {label}
            </Label>
          )}
        </div>
      )}
      rules={rules}
    />
  )
}
